export const SNOW_FALL_MONIKER = "Snow Fall";
export const SNOW_FALL_FP_BTC_PK =
  "eff010c66fc56784e708202e49bd875f8b08b8a1a40f0e7638e93ef1366a13d7";
export const SNOW_FALL_VALIDATOR_ADDRESS =
  "bbnvaloper1uhwy40w2jg22m2yup4qepqa420x2tfz0hrgu9w";

export const isSnowFallMoniker = (moniker?: string) =>
  moniker?.trim().toLowerCase() === SNOW_FALL_MONIKER.toLowerCase();

export const isSnowFallFinalityProvider = (fp?: {
  btcPk?: string;
  description?: { moniker?: string };
}) =>
  fp?.btcPk === SNOW_FALL_FP_BTC_PK ||
  isSnowFallMoniker(fp?.description?.moniker);

export const isSnowFallValidator = (validator?: {
  address?: string;
  name?: string;
}) =>
  validator?.address === SNOW_FALL_VALIDATOR_ADDRESS ||
  isSnowFallMoniker(validator?.name);
